import React from 'react';
import styles from '../StoreGuide.module.scss';
import SupportEmailLink from '../../../components/SupportEmailLink/SupportEmailLink';
import DiscordInviteButton from '../../../components/DiscordInviteButton/DiscordInviteButton';

const SteamGuide: React.FC = () => {
  return (
    <div className={styles.guideContent}>
      <div className={styles.guideHeader}>
        <img 
          src={`${process.env.PUBLIC_URL}/images/icons/steam-icon.svg`}
          alt="Steam"
          className={styles.storeLogo}
          onError={(e) => {
            const target = e.currentTarget;
            target.onerror = null;
            target.style.display = 'none';
          }}
        />
        <div className={styles.storeTitle}>
          <h1>Product key activation on Steam</h1>
          <p>Follow these steps to activate your Product Key on Steam</p>
        </div>
      </div>

      <div className={styles.stepsContainer}>
        <h2 className={styles.stepsTitle}>Step-by-Step Instructions</h2>
        <div className={styles.steps}>
          
          <div className={styles.step}>
            <div className={styles.stepNumber}>
              <span>1</span>
            </div>
            <div className={styles.stepContent}>
              <h3 className={styles.stepTitle}>Install Steam Client Application</h3>
              <div className={styles.stepDescription}>
                In order to activate your Product Key on Steam, first you need to install the Steam Client Application. You can download it{' '}
                <a 
                  href="https://store.steampowered.com/about/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className={styles.inlineLink}
                >
                  here
                </a>.
              </div>
              <div className={styles.stepImage}>
                <img 
                  src={`${process.env.PUBLIC_URL}/images/activation-guides/steam-step-1.png`}
                  alt="Step 1: Install Steam Client Application"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.onerror = null;
                    target.style.display = 'none';
                  }}
                />
              </div>
            </div>
          </div>

          <div className={styles.step}>
            <div className={styles.stepNumber}>
              <span>2</span>
            </div>
            <div className={styles.stepContent}>
              <h3 className={styles.stepTitle}>Sign In and Add Game</h3>
              <div className={styles.stepDescription}>
                After you download and launch the app, sign in with your Steam logins, and select{' '}
                <strong className={styles.boldText}>'ADD A GAME'</strong> as showed in the picture below. You will get 3 options from which you need to select the{' '}
                <strong className={styles.boldText}>'Activate a Product on Steam'</strong> option.
              </div>
              <div className={styles.stepImage}>
                <img 
                  src={`${process.env.PUBLIC_URL}/images/activation-guides/steam-step-2.png`}
                  alt="Step 2: Sign In and Add Game"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.onerror = null;
                    target.style.display = 'none';
                  }}
                />
              </div>
            </div>
          </div>

          <div className={styles.step}>
            <div className={styles.stepNumber}>
              <span>3</span>
            </div>
            <div className={styles.stepContent}>
              <h3 className={styles.stepTitle}>Start Product Activation</h3>
              <div className={styles.stepDescription}>
                After the Product Activation window pops up, select <strong className={styles.boldText}>'Next'</strong>.
              </div>
              <div className={styles.stepImage}>
                <img 
                  src={`${process.env.PUBLIC_URL}/images/activation-guides/steam-step-3.png`}
                  alt="Step 3: Start Product Activation"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.onerror = null;
                    target.style.display = 'none';
                  }}
                />
              </div>
            </div>
          </div>

          <div className={styles.step}>
            <div className={styles.stepNumber}>
              <span>4</span>
            </div>
            <div className={styles.stepContent}>
              <h3 className={styles.stepTitle}>Accept Steam Subscriber Agreement</h3>
              <div className={styles.stepDescription}>
                Select <strong className={styles.boldText}>'I Agree'</strong> option, since Steam Subscriber Agreement needs to be agreed with in order to continue.
              </div>
              <div className={styles.stepImage}>
                <img 
                  src={`${process.env.PUBLIC_URL}/images/activation-guides/steam-step-4.png`}
                  alt="Step 4: Accept Steam Subscriber Agreement"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.onerror = null;
                    target.style.display = 'none';
                  }}
                />
              </div>
            </div>
          </div>

          <div className={styles.step}>
            <div className={styles.stepNumber}>
              <span>5</span>
            </div>
            <div className={styles.stepContent}>
              <h3 className={styles.stepTitle}>Enter Product Key</h3>
              <div className={styles.stepDescription}>
                Copy the Game Key and paste it in the Product Code field, then click <strong className={styles.boldText}>'Next'</strong>.
              </div>
              <div className={styles.stepImage}>
                <img 
                  src={`${process.env.PUBLIC_URL}/images/activation-guides/steam-step-5.png`}
                  alt="Step 5: Enter Product Key"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.onerror = null;
                    target.style.display = 'none';
                  }}
                />
              </div>
            </div>
          </div>

          <div className={styles.step}>
            <div className={styles.stepNumber}>
              <span>6</span>
            </div>
            <div className={styles.stepContent}>
              <h3 className={styles.stepTitle}>OnePlay Support</h3>
              <div className={styles.stepDescription}>
                <div style={{ marginBottom: '12px' }}>
                  For any assistance please contact us via email at <SupportEmailLink /> or join our Discord channel:
                </div>
                <DiscordInviteButton />
              </div>
            </div>
          </div>

        </div>
      </div>

      {/* <div className={styles.additionalNotes}>
        <h3>Important Notes</h3>
        <ul>
          <li>Steam gift cards can only be redeemed in the same currency and region where they were purchased</li>
          <li>Some games may have regional restrictions</li>
          <li>If you encounter issues, check that the code hasn't already been used</li>
        </ul>
      </div> */}

      {/* <div className={styles.support}>
        <h3>Need More Help?</h3>
        <p>
          If you encounter any issues during the activation process, visit the official{' '}
          <a 
            href="https://help.steampowered.com/" 
            target="_blank" 
            rel="noopener noreferrer"
            className={styles.supportLink}
          >
            Steam Support Center
          </a>
          {' '}for additional assistance.
        </p>
      </div> */}

      {/* Steam Gift Card Section */}
      <div className={styles.giftCardSection}>
        <h2>How to activate a Steam Gift Card?</h2>
        
        <div className={styles.giftCardSteps}>
          <h3>You may redeem your Steam Gift Card in just a few simple steps:</h3>
          
          <div className={styles.steps}>
            <div className={styles.step}>
              <div className={styles.stepNumber}>
                <span>1</span>
              </div>
              <div className={styles.stepContent}>
                <div className={styles.stepDescription}>
                  Access your Steam account;
                </div>
              </div>
            </div>

            <div className={styles.step}>
              <div className={styles.stepNumber}>
                <span>2</span>
              </div>
              <div className={styles.stepContent}>
                <div className={styles.stepDescription}>
                  To begin, click your account name in the upper right corner of the site, followed by Account information.
                </div>
              </div>
            </div>

            <div className={styles.step}>
              <div className={styles.stepNumber}>
                <span>3</span>
              </div>
              <div className={styles.stepContent}>
                <div className={styles.stepDescription}>
                  Select <strong className={styles.boldText}>Add Funds to Steam Wallet</strong>;
                </div>
              </div>
            </div>

            <div className={styles.step}>
              <div className={styles.stepNumber}>
                <span>4</span>
              </div>
              <div className={styles.stepContent}>
                <div className={styles.stepDescription}>
                  Select <strong className={styles.boldText}>Redeem a Steam Wallet Code</strong> from the drop-down menu.
                </div>
              </div>
            </div>

            <div className={styles.step}>
              <div className={styles.stepNumber}>
                <span>5</span>
              </div>
              <div className={styles.stepContent}>
                <div className={styles.stepDescription}>
                  Enter the Steam Gift Card code that was emailed to you;
                </div>
              </div>
            </div>

            <div className={styles.step}>
              <div className={styles.stepNumber}>
                <span>6</span>
              </div>
              <div className={styles.stepContent}>
                <div className={styles.stepDescription}>
                  Choose <strong className={styles.boldText}>Continue</strong>. It's worth noting that if you've never used Steam Wallet credit on your account, you could be asked to input your current address to identify the suitable currency.
                </div>
              </div>
            </div>

            <div className={styles.step}>
              <div className={styles.stepNumber}>
                <span>7</span>
              </div>
              <div className={styles.stepContent}>
                <div className={styles.stepDescription}>
                  <div style={{ marginBottom: '12px' }}>
                    For any assistance please contact us via email at <SupportEmailLink /> or join our Discord channel:
                  </div>
                  <DiscordInviteButton />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className={styles.giftCardInfo}>
          <p>
            Add money to your Steam Wallet to play your favourite PC, Mac, and SteamOS games. Thousands of games from world-class developers and publishers are available now. If you had a good buying experience and need more Steam cards, check out our Steam gift card selection.
          </p>
        </div>
      </div>
    </div>
  );
};

export default SteamGuide; 